import React, { useState } from 'react';
import AdminCRUD from '../../components/admin/AdminCRUD';
import I18nForm from '../../components/admin/I18nForm';

const TYPES = ['blog', 'news', 'report', 'podcast'];

const NewsForm = ({ initialData, onSave, onCancel }) => {
  const d = initialData || {};
  const [form, setForm] = useState({
    title:        d.title        || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    excerpt:      d.excerpt      || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    content:      d.content      || { en: '', 'zh-CN': '', 'zh-TW': '', ja: '' },
    slug:         d.slug         || '',
    type:         d.type         || 'blog',
    author:       d.author       || '',
    externalUrl:  d.externalUrl  || '',
    publication:  d.publication  || '',
    publishedAt:  d.publishedAt  ? new Date(d.publishedAt).toISOString().slice(0,10) : new Date().toISOString().slice(0,10),
    tags:         (d.tags || []).join(', '),
    isActive:     d.isActive !== false,
  });

  const inputStyle = { width: '100%', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px 10px', fontSize: '13px', color: '#334155', outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ ...form, publishedAt: new Date(form.publishedAt), tags: form.tags.split(',').map(t => t.trim()).filter(Boolean) });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
        <I18nForm label="Title" value={form.title} onChange={v => setForm(f => ({ ...f, title: v }))} />
        <div>
          <label style={labelStyle}>Slug</label>
          <input value={form.slug} onChange={e => setForm(f => ({ ...f, slug: e.target.value }))} required style={inputStyle} />
        </div>
      </div>

      <I18nForm label="Excerpt" value={form.excerpt} onChange={v => setForm(f => ({ ...f, excerpt: v }))} multiline rows={2} />
      <I18nForm label="Content (HTML)" value={form.content} onChange={v => setForm(f => ({ ...f, content: v }))} multiline rows={6} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '12px', marginBottom: '14px' }}>
        <div>
          <label style={labelStyle}>Type</label>
          <select value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))} style={{ ...inputStyle, background: '#fff' }}>
            {TYPES.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Author</label>
          <input value={form.author} onChange={e => setForm(f => ({ ...f, author: e.target.value }))} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Published Date</label>
          <input type="date" value={form.publishedAt} onChange={e => setForm(f => ({ ...f, publishedAt: e.target.value }))} style={inputStyle} />
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '2px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#334155', cursor: 'pointer' }}>
            <input type="checkbox" checked={form.isActive} onChange={e => setForm(f => ({ ...f, isActive: e.target.checked }))} />
            Active
          </label>
        </div>
      </div>

      <div style={{ marginBottom: '14px' }}>
        <label style={labelStyle}>Tags (comma-separated)</label>
        <input value={form.tags} onChange={e => setForm(f => ({ ...f, tags: e.target.value }))} style={inputStyle} placeholder="e.g. Robotics, STEM, Kentucky" />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
        <div>
          <label style={labelStyle}>External URL (optional)</label>
          <input value={form.externalUrl} onChange={e => setForm(f => ({ ...f, externalUrl: e.target.value }))} style={inputStyle} placeholder="https://..." />
        </div>
        <div>
          <label style={labelStyle}>Publication (optional)</label>
          <input value={form.publication} onChange={e => setForm(f => ({ ...f, publication: e.target.value }))} style={inputStyle} placeholder="e.g. McKinsey" />
        </div>
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button type="submit" style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>Save</button>
        <button type="button" onClick={onCancel} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', cursor: 'pointer' }}>Cancel</button>
      </div>
    </form>
  );
};

const COLUMNS = [
  { key: 'title', label: 'Title (EN)', render: item => item.title?.en || '' },
  { key: 'type', label: 'Type' },
  { key: 'author', label: 'Author' },
  { key: 'publishedAt', label: 'Published', render: item => item.publishedAt ? new Date(item.publishedAt).toLocaleDateString() : '' },
  { key: 'isActive', label: 'Active', render: item => item.isActive ? '✅' : '❌' },
];

const AdminNews = () => (
  <AdminCRUD
    title="News & Insights"
    apiPath="/api/admin/news"
    columns={COLUMNS}
    FormComponent={NewsForm}
  />
);

export default AdminNews;
